<template>
    <nav class="navbar navbar-expand-md navbar-dark fixed-top">
        <div class="container">
            <router-link to="/" class="navbar-brand" v-html="require('svg-inline-loader!../assets/logo.svg-inline')">
            </router-link>
            <!--
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
            -->
            <div class="collapse navbar-collapse" id="navbarNavDropdown">
                <slot name="nav">
                </slot>
                <social-navigation class="ml-auto"></social-navigation>
            </div>
        </div>
    </nav>
</template>

<script>
import SocialNavigation from './SocialNavigation';
export default {
    components: {
        SocialNavigation
    }
}
</script>
